var React = require('react');

function LineLeftMobile (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m60 0v48.375l-59-0.625v36.742","stroke":"#dae0e5","strokeWidth":"2","fill":"none"}));
}

LineLeftMobile.defaultProps = {"height":"85","width":"119","viewBox":"0 0 119 85"};

module.exports = LineLeftMobile;

LineLeftMobile.default = LineLeftMobile;
